import { Component,Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
@Component({
  selector: 'app-okay-dialogbox',
  templateUrl: './okay-dialogbox.component.html',
  styleUrls: ['./okay-dialogbox.component.scss']
})
export class OkayDialogboxComponent implements OnInit {
  selectedIssue;
  constructor(
     public dialogRef: MatDialogRef<OkayDialogboxComponent>,
      @Inject(MAT_DIALOG_DATA) public data
  ) { 
    this.selectedIssue=data;
  }

  ngOnInit(): void {
  }
  onConfirm() {
    this.dialogRef.close(); // Return true when user confirms
  }

  onCancel() {
    this.dialogRef.close(); // Return false when user cancels
  }

}
